import React, { useState } from "react";
import ModalComponent from "../ModalComponent";
import "./style.css";
import { useTranslation } from "react-i18next";

interface IProps {
  text: string;
  minLengthText: number;
  title: string;
}




const ReadMore: React.FC<IProps> = ({ text, minLengthText, title }: IProps) => {
  const [readMore, setReadMore] = useState(false);
  const { t } = useTranslation();



  return (
    <React.Fragment>




      <article dangerouslySetInnerHTML={{ __html: text.slice(0, minLengthText) + "..." }}></article>

      <button className="button small padding-zero button-text-main full-button" onClick={() => setReadMore(!readMore)}>
        {t("przeczytaj_calosc")}
      </button>

      {readMore && (
        <div className="schedule-modal-info">
          <ModalComponent
            footer={false}
            open={readMore}
            closeModal={() => setReadMore(false)}
            title={title}
            onAccept={() => setReadMore(false)}
            acceptText={t("przeczytalem")}
          >
            <p className="news-modal-body" dangerouslySetInnerHTML={{ __html: text }}></p>
          </ModalComponent>
        </div>
      )}
    </React.Fragment>
  );
};

export default ReadMore;
